import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

export const StyledBundleProductBadge = styled.div`
  box-sizing: border-box;
  display: flex;
  width: fit-content;
  height: 30px;
  border-radius: 30px;
  border: 1px solid ${(props) => props.theme.colorPalette.green[500]};
  background: rgba(255, 255, 255, 0.9);
  padding: 8px;
  column-gap: 6px;

  & img.items-in-bag-success-icon {
    width: 13px;
    height: 13px;
    position: unset;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    height: 32px;

    & img.items-in-bag-success-icon {
      width: 16px;
      height: 16px;
    }
  }
`;

export const StyledBundleProductBadgeText = styled(BodyCopy)`
  font-size: 10px;
  line-height: 14px;

  @media ${(props) => props.theme.mediaQuery.large} {
    font-size: 12px;
    line-height: 16px;
  }
`;
